import {UniversalLoginInstance} from 'app/modules/auth/types/universalLogin'

import {PasswordResetConflictResponse} from './types'

export const isPasswordResetConflict = (
  res: PasswordResetConflictResponse
): res is PasswordResetConflictResponse & {
  statusCode: 409
  result: {instances: UniversalLoginInstance[]}
} => res?.statusCode === 409 && Boolean(res?.result?.instances?.length)
